import { HistoryMergerBasedByMin } from './HistoryMergerBasedByMin';
import { Interval } from '@shared/utils/History/Interval';
export class HistoryMergerIntrdayBySession extends HistoryMergerBasedByMin {
    constructor(inputParams) {
        super(inputParams);
        this.isFilterNotAllowedPeriods = inputParams.IsFilterNotAllowedPeriods;
        this.showExtendedSession = inputParams.ShowExtendedSession;
    }
    GetStartPoint(date) {
        const [startSession, endSession] = this.instrument.Session.GetSessionPeriodRange(date, this.isFilterNotAllowedPeriods, this.showExtendedSession);
        if (startSession.getTime() === 0 || endSession.getTime() === 0) {
            return Interval.GetInvalidInterval();
        }
        const interval = new Interval();
        interval.From = startSession;
        interval.To = endSession;
        return interval;
    }
}
